import { useFormContext } from 'react-hook-form';

import StringInput from 'components/field/StringInput';
import FormItem from 'components/form/FormItem';
import Checkbox from 'components/global/Checkbox';

const validateOptions = {
	shouldValidate: true,
	shouldDirty: true
};

const defaultColSpan = {
	md: 6
};

const PaytrIframe = ({ loading, subscription }) => {
	const formMethods = useFormContext();
	const { setValue, watch, setError } = formMethods;

	const changeCardNumber = (e) => {
		setError('cardNumber', null);
		let value = e.target.value;
		value = value.replace(/\D/g, '') || '';
		if (!value) {
			e.target.value = '';
			return;
		}
		if (value.length > 16) {
			value = value.slice(0, 16);
		}
		value = value.match(new RegExp('.{1,4}', 'g')).join(' ');
		setValue('cardNumber', value, validateOptions);
	};

	const changeCardExpiry = (e) => {
		setError('cardExpiry', null);
		let value = e.target.value;
		value = value.replace(/\D/g, '');
		if (value.length > 4) {
			value = value.slice(0, 4);
		}
		if (value.length > 2) {
			value = `${value.slice(0, 2)}/${value.slice(2)}`;
		}
		setValue('cardExpiry', value, validateOptions);
	};

	const changeCvv = (e) => {
		setError('cvv', null);
		let value = e.target.value;
		value = value.replace(/\D/g, '');
		if (value.length > 3) {
			value = value.slice(0, 3);
		}
		setValue('cvv', value, validateOptions);
	};

	return (
		<>
			<FormItem label="cardHolderName" colSpan={defaultColSpan} isLoading={loading} required>
				<StringInput
					id="card-holder"
					name="cardHolderName"
					autoComplete="cc-name"
					placeholder="cardHolderName"
					maxLength="26"
				/>
			</FormItem>

			<FormItem label="cardNumber" colSpan={defaultColSpan} isLoading={loading} required>
				<StringInput
					id="card-number"
					autoComplete="cc-number"
					name="cardNumber"
					placeholder="cardNumber"
					maxLength={20}
					onChange={changeCardNumber}
				/>
			</FormItem>

			<FormItem label="cardExpiry" colSpan={defaultColSpan} isLoading={loading} required>
				<StringInput
					id="expiration-date"
					autoComplete="cc-exp"
					name="cardExpiry"
					placeholder="MM/YY"
					maxLength={5}
					onChange={changeCardExpiry}
				/>
			</FormItem>

			<FormItem label="card.cvv" colSpan={defaultColSpan} isLoading={loading} required>
				<StringInput
					id="cvv"
					name="cvv"
					autoComplete="cc-csc"
					placeholder="card.cvv"
					maxLength={3}
					onChange={changeCvv}
				/>
			</FormItem>

			{!subscription && (
				<div onClick={() => setValue('saveCard', !watch('saveCard'), validateOptions)}>
					<FormItem label="saveCardForFuturePayments" direction="row-reverse">
						<Checkbox checked={watch('saveCard')} readOnly />
					</FormItem>
				</div>
			)}
		</>
	);
};
export default PaytrIframe;
